import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from "dayjs";
import Calendar from '../calendar/Calendar.js';
import CanvasJSReact_ChartPerformance from '../chart/ChartPerformance';

import ModalLoad from '../modal/ModalLoad';
import ModalPopupMessage from '../modal/ModalPopupMessage';
import ScrollToTopButton from '../extra/ScrollToTopButton.js';

function MeasurementPerformance(props) {
    const [reportsite, setReportsite] = useState('-');
    const [reporttype_picker, setReporttype_picker] = useState('day');
    const [reporttype, setReporttype] = useState('daily');
    const [reportdate_dt, setReportdate_dt] = useState(dayjs(new Date()));
    const [calendar_text, setCalendar_text] = useState('Date');

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const onCalendaraChange = (date, dateString) => {
        setReportdate_dt(date)
    };

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        return () => {
            setChart_plot({})
        };
    }, []);

    useEffect(() => {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.sitescope_arr !== null && props.permitdata.sitescope_arr !== undefined) {
                setReportsite(props.permitdata.sitescope_arr[0].sitecode_txt)
            }
        }
    }, [props.permitdata]);

    useEffect(() => {
        if (reporttype !== undefined) {
            if (reporttype === "daily") {
                setReporttype_picker("date")
                setCalendar_text("Date")
            } else if (reporttype === "monthly") {
                setReporttype_picker("month")
                setCalendar_text("Month")
            } else if (reporttype === "yearly") {
                setReporttype_picker("year")
                setCalendar_text("Year")
            } else if (reporttype === "cod") {
                setReporttype_picker("month")
            }
        }
    }, [reporttype]);

    function disabledCalendar(current) {
        if (reporttype === "daily") {
            return current.isBefore(props.permitdata.cod_date, 'day') || current.isAfter(dayjs(new Date()).format("YYYY-MM-DD 23:59:59"), 'day')
        } else if (reporttype === "monthly") {
            return current.isBefore(props.permitdata.cod_date, 'month') || current.isAfter(dayjs(new Date()).subtract(1, 'days').format("YYYY-MM-DD 23:59:59"), 'month')
        } else if (reporttype === "yearly") {
            return current.isBefore(props.permitdata.cod_date, 'year') || current.isAfter(dayjs(new Date()).format("YYYY-MM-DD 23:59:59"), 'year')
        }
    }

    const [chart_plot, setChart_plot] = useState({
        FileName: '',
        CSV_Data: [],
        XLabel: '',
        Sitename: '-',
        Energy: [],
        PR: [],
        PRG: [],
        ORx: [],
        ORG: [],
        ENS: [],
        Saving: [],
        Value: [],
        CO2: [],
        Approx: [],
        errorx: [],
        CODData: null,
        Chart1_Style: { unit: "kWh", digit: 3, type: "column", axis_y1: 'Solar Energy (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart2_Style: { unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart3_Style: { unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart4_Style: { unit: "kWh", digit: 3, type: "column", axis_y1: 'Energy not Supply (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart5_Style: { unit: "Ton", digit: 3, type: "column", axis_y1: 'CO2 Reduction (Ton)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart6_Style: { unit: "THB", digit: 3, type: "column", axis_y1: 'Saving (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart7_Style: { unit: "THB", digit: 3, type: "column", axis_y1: 'Energy Value (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        summary: { Energy: 0, PRx: 0, ORx: 0, ENS: 0, Saving: 0, Value: 0, CO2: 0 },
        summary_unit: { Energy: "-", PRx: "-", ORx: "-", ENS: "-", Saving: "-", Value: "-", CO2: "-", },
        unit_rate: [],
        co2_factor: [],
        holiday: []
    });

    async function api_query() {
        let dt = ""
        if (reporttype === "daily") {
            dt = dayjs(new Date(reportdate_dt)).format("YYYY-MM-DD") + " 00:00:00"
        } else if (reporttype === "monthly") {
            dt = dayjs(new Date(reportdate_dt)).format("YYYY-MM") + "-01 00:00:00"
        } else if (reporttype === "yearly") {
            dt = dayjs(new Date(reportdate_dt)).format("YYYY") + "-01-01 00:00:00"
        } else if (reporttype === "cod") {
            dt = dayjs(new Date(reportdate_dt)).format("YYYY") + "-01-01 00:00:00"
        }

        setmodal_load({ enable: true, message: "Query historical performance." })
        await sleep(500)

        const formData = new FormData();
        formData.append('post_url', "/proxy/center/api/historical/production")
        formData.append('token', props.permitdata.token)

        formData.append('reporttype', reporttype)
        formData.append('reportdate', dt)
        if (props.permitdata.view_mode === "local") {
            formData.append('reportsite', props.permitdata.sitecode)
        } else {
            formData.append('reportsite', reportsite)
        }

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/historical/production", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    let daplot = {
                        XLabel: response.data.plot.XLabel,
                        Sitename: response.data.sitename,
                        Energy: [],
                        Energy_onpeak: [],
                        Energy_offpeak: [],
                        PR: [],
                        PRG: [],
                        ORx: [],
                        ORG: [],
                        ENS: [],
                        Saving: [],
                        Saving_onpeak: [],
                        Saving_offpeak: [],
                        Saving_usage: [],
                        Saving_ft: [],
                        Value: [],
                        Value_onpeak: [],
                        Value_offpeak: [],
                        Value_usage: [],
                        Value_ft: [],
                        CO2: [],
                        errorx: [],
                        CODData: null,
                        Chart1_Style: {},
                        Chart2_Style: {},
                        Chart3_Style: {},
                        Chart4_Style: {},
                        Chart5_Style: {},
                        Chart6_Style: {},
                        Chart7_Style: {},
                        unit_rate: [],
                        unit_rate_onpeak: [],
                        unit_rate_offpeak: [],
                        ft_val: [],
                        co2_factor: [],
                        holiday: []
                    }

                    daplot.Chart2_Style.start = new Date(response.data.plot.Data[0].x)
                    daplot.Chart3_Style.start = new Date(response.data.plot.Data[0].x)
                    for (let i = 0; i < response.data.plot.Data.length; i++) {
                        const dx = new Date(response.data.plot.Data[i].x)

                        daplot.Energy.push({ x: dx, y: response.data.plot.Data[i]['solar'] })
                        if (response.data.plot.Data[0]['solar_onpeak'] !== undefined) {
                            daplot.Energy_onpeak.push(response.data.plot.Data[i]['solar_onpeak'])
                            daplot.Energy_offpeak.push(response.data.plot.Data[i]['solar_offpeak'])
                        } else {
                            daplot.Energy_onpeak = undefined
                            daplot.Energy_offpeak = undefined
                        }
                        daplot.PR.push({ x: dx, y: response.data.plot.Data[i]['pr_ens'] })
                        daplot.PRG.push({ x: dx, y: response.data.plot.Data[i]['prg'] })
                        daplot.ORx.push({ x: dx, y: response.data.plot.Data[i]['orx_ens'] })
                        daplot.ORG.push({ x: dx, y: response.data.plot.Data[i]['org'] })
                        daplot.ENS.push({ x: dx, y: response.data.plot.Data[i]['ens'] })
                        daplot.Saving.push({ x: dx, y: response.data.plot.Data[i]['saving'] })
                        if (response.data.plot.Data[0]['saving_onpeak'] !== undefined) {
                            daplot.Saving_onpeak.push(response.data.plot.Data[i]['saving_onpeak'])
                            daplot.Saving_offpeak.push(response.data.plot.Data[i]['saving_offpeak'])
                        } else {
                            daplot.Saving_onpeak = undefined
                            daplot.Saving_offpeak = undefined
                        }
                        if (response.data.plot.Data[0]['saving_hourly'] !== undefined) {
                            daplot.Saving_usage.push(response.data.plot.Data[i]['saving_hourly'])
                        } else {
                            daplot.Saving_usage = undefined
                        }
                        if (response.data.plot.Data[0]['saving_ft'] !== undefined) {
                            daplot.Saving_ft.push(response.data.plot.Data[i]['saving_ft'])
                        } else {
                            daplot.Saving_ft = undefined
                        }
                        daplot.Value.push({ x: dx, y: response.data.plot.Data[i]['value'] })
                        if (response.data.plot.Data[0]['value_onpeak'] !== undefined) {
                            daplot.Value_onpeak.push(response.data.plot.Data[i]['value_onpeak'])
                            daplot.Value_offpeak.push(response.data.plot.Data[i]['value_offpeak'])
                        } else {
                            daplot.Value_onpeak = undefined
                            daplot.Value_offpeak = undefined
                        }
                        if (response.data.plot.Data[0]['value_hourly'] !== undefined) {
                            daplot.Value_usage.push(response.data.plot.Data[i]['value_hourly'])
                        } else {
                            daplot.Value_usage = undefined
                        }
                        if (response.data.plot.Data[0]['value_ft'] !== undefined) {
                            daplot.Value_ft.push(response.data.plot.Data[i]['value_ft'])
                        } else {
                            daplot.Value_ft = undefined
                        }
                        daplot.CO2.push({ x: dx, y: response.data.plot.Data[i]['co2'] })

                        daplot.unit_rate.push(response.data.plot.Data[i]['unit_rate'])
                        if (response.data.plot.Data[0]['unit_rate_onpeak'] !== undefined) {
                            daplot.unit_rate_onpeak.push(response.data.plot.Data[i]['unit_rate_onpeak'])
                            daplot.unit_rate_offpeak.push(response.data.plot.Data[i]['unit_rate_offpeak'])
                        } else {
                            daplot.unit_rate_onpeak = undefined
                            daplot.unit_rate_offpeak = undefined
                        }
                        if (response.data.plot.Data[0]['ft_val'] !== undefined) {
                            daplot.ft_val.push(response.data.plot.Data[i]['ft_val'])
                        } else {
                            daplot.ft_val = undefined
                        }
                        daplot.co2_factor.push(response.data.plot.Data[i]['co2_factor'])
                        daplot.errorx.push(response.data.plot.Data[i]['error'])
                        if (response.data.plot.Data[0]['holiday'] !== undefined) {
                            daplot.holiday.push(response.data.plot.Data[i]['holiday'])
                        } else {
                            daplot.holiday = undefined
                        }
                    }

                    if (reporttype === "daily") {
                        daplot.Chart1_Style = { unit: "kWh", digit: 2, type: "column", axis_y1: 'Solar Energy (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical', start: null }
                        daplot.Chart2_Style = { unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical', start: null }
                        daplot.Chart3_Style = { unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical', start: null }
                        daplot.Chart4_Style = { unit: "kWh", digit: 3, type: "column", axis_y1: 'Energy not Supply (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical', start: null }
                        daplot.Chart5_Style = { unit: "kgCO<sub>2</sub>", digit: 3, type: "column", axis_y1: 'CO2 Reduction (kgCO2)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical', start: null }
                        daplot.Chart6_Style = { unit: "THB", digit: 2, type: "column", axis_y1: 'Saving (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical', start: null }
                        daplot.Chart7_Style = { unit: "THB", digit: 2, type: "column", axis_y1: 'Energy Value (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical', start: null }
                        daplot.CODData = null
                    } else if (reporttype === "monthly") {
                        daplot.Chart1_Style = { unit: "kWh", digit: 2, type: "column", axis_y1: 'Solar Energy (kWh)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart2_Style = { unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart3_Style = { unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart4_Style = { unit: "KWh", digit: 3, type: "column", axis_y1: 'Energy not Supply (kWh)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart5_Style = { unit: "kgCO<sub>2</sub>", digit: 3, type: "column", axis_y1: 'CO2 Reduction (kgCO2)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart6_Style = { unit: "THB", digit: 2, type: "column", axis_y1: 'Saving (THB)', xinterval: 'day', xformat: 'DD', yformat: '#0.###,.k', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart7_Style = { unit: "THB", digit: 2, type: "column", axis_y1: 'Energy Value (THB)', xinterval: 'day', xformat: 'DD', yformat: '#0.###,.k', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
                        daplot.CODData = { CODIndex_Start: response.data.plot.CODData.CODIndex_Start, CODIndex_Stop: response.data.plot.CODData.CODIndex_Stop }
                    } else if (reporttype === "yearly") {
                        daplot.Chart1_Style = { unit: "MWh", digit: 3, type: "column", axis_y1: 'Solar Energy (MWh)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart2_Style = { unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart3_Style = { unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart4_Style = { unit: "MWh", digit: 3, type: "column", axis_y1: 'Energy not Supply (MWh)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart5_Style = { unit: "tonCO<sub>2</sub>", digit: 3, type: "column", axis_y1: 'CO2 Reduction (tonCO2)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart6_Style = { unit: "THB", digit: 2, type: "column", axis_y1: 'Saving (THB)', xinterval: 'month', xformat: 'MMM', yformat: '#0.###,.k', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart7_Style = { unit: "THB", digit: 2, type: "column", axis_y1: 'Energy Value (THB)', xinterval: 'month', xformat: 'MMM', yformat: '#0.###,.k', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
                        daplot.CODData = { CODIndex_Start: response.data.plot.CODData.CODIndex_Start, CODIndex_Stop: response.data.plot.CODData.CODIndex_Stop }
                    } else if (reporttype === "cod") {
                        daplot.Chart1_Style = { unit: "MWh", digit: 3, type: "column", axis_y1: 'Solar Energy (MWh)', xinterval: 'year', xformat: 'YYYY', tooltip_header: 'Year', tooltip_format: 'YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart2_Style = { unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'year', xformat: 'YYYY', tooltip_header: 'Year', tooltip_format: 'YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart3_Style = { unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'year', xformat: 'YYYY', tooltip_header: 'Year', tooltip_format: 'YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart4_Style = { unit: "MWh", digit: 3, type: "column", axis_y1: 'Energy not Supply (MWh)', xinterval: 'year', xformat: 'YYYY', tooltip_header: 'Year', tooltip_format: 'YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart5_Style = { unit: "tonCO<sub>2</sub>", digit: 3, type: "column", axis_y1: 'CO2 Reduction (tonCO2)', xinterval: 'year', xformat: 'YYYY', tooltip_header: 'Year', tooltip_format: 'YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart6_Style = { unit: "THB", digit: 2, type: "column", axis_y1: 'Saving (THB)', xinterval: 'year', xformat: 'YYYY', yformat: '#0.###,.k', tooltip_header: 'Year', tooltip_format: 'YYYY', indexlabel: 'vertical', start: null }
                        daplot.Chart7_Style = { unit: "THB", digit: 2, type: "column", axis_y1: 'Energy Value (THB)', xinterval: 'year', xformat: 'YYYY', yformat: '#0.###,.k', tooltip_header: 'Year', tooltip_format: 'YYYY', indexlabel: 'vertical', start: null }
                        daplot.CODData = null
                    }

                    setChart_plot({
                        ...chart_plot,
                        FileName: response.data.plot.filename,
                        CSV_Data: response.data.plot.Data,
                        XLabel: daplot.XLabel,
                        Sitename: daplot.Sitename,
                        Energy: daplot.Energy,
                        Energy_onpeak: daplot.Energy_onpeak,
                        Energy_offpeak: daplot.Energy_offpeak,
                        PR: daplot.PR,
                        PRG: daplot.PRG,
                        ORx: daplot.ORx,
                        ORG: daplot.ORG,
                        ENS: daplot.ENS,
                        Saving: daplot.Saving,
                        Saving_onpeak: daplot.Saving_onpeak,
                        Saving_offpeak: daplot.Saving_offpeak,
                        Saving_ft: daplot.Saving_ft,
                        Saving_usage: daplot.Saving_usage,
                        Value: daplot.Value,
                        Value_onpeak: daplot.Value_onpeak,
                        Value_offpeak: daplot.Value_offpeak,
                        Value_ft: daplot.Value_ft,
                        Value_usage: daplot.Value_usage,
                        CO2: daplot.CO2,
                        errorx: daplot.errorx,
                        CODData: daplot.CODData,
                        Chart1_Style: daplot.Chart1_Style,
                        Chart2_Style: daplot.Chart2_Style,
                        Chart3_Style: daplot.Chart3_Style,
                        Chart4_Style: daplot.Chart4_Style,
                        Chart5_Style: daplot.Chart5_Style,
                        Chart6_Style: daplot.Chart6_Style,
                        Chart7_Style: daplot.Chart7_Style,
                        summary: {
                            Energy: response.data.plot.Summary['sum_energy'],
                            PRx: response.data.plot.Summary['pr_ens'],
                            ORx: response.data.plot.Summary['orx_ens'],
                            ENS: response.data.plot.Summary['sum_ens'],
                            Saving: response.data.plot.Summary['sum_saving'],
                            Value: response.data.plot.Summary['sum_value'],
                            CO2: response.data.plot.Summary['sum_co2'],
                        },
                        summary_unit: {
                            Energy: response.data.plot.Summary_Unit['sum_energy'],
                            PRx: response.data.plot.Summary_Unit['pr_ens'],
                            ORx: response.data.plot.Summary_Unit['orx_ens'],
                            ENS: response.data.plot.Summary_Unit['sum_ens'],
                            Saving: response.data.plot.Summary_Unit['sum_saving'],
                            Value: response.data.plot.Summary_Unit['sum_value'],
                            CO2: response.data.plot.Summary_Unit['sum_co2'],
                        },
                        unit_rate: daplot.unit_rate,
                        unit_rate_onpeak: daplot.unit_rate_onpeak,
                        unit_rate_offpeak: daplot.unit_rate_offpeak,
                        ft_val: daplot.ft_val,
                        co2_factor: daplot.co2_factor,
                        holiday: daplot.holiday
                    })
                }
                else {
                    reset_chart()
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                reset_chart()
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function export_csv() {
        let firstcol = 'Hour'
        if (reporttype === "daily") {
            firstcol = 'Hour'
        } else if (reporttype === "monthly") {
            firstcol = 'Date'
        } else if (reporttype === "yearly") {
            firstcol = 'Month'
        } else if (reporttype === "cod") {
            firstcol = 'Year'
        }

        let tableheader = [firstcol,
            'Solar Energy (' + chart_plot.Chart1_Style.unit + ')',
            'PR (%)',
            'OR (%)',
            'Energy not Supply (' + chart_plot.Chart4_Style.unit + ')',
            'CO2 (' + chart_plot.Chart5_Style.unit + ')',
            'Estimate Saving (THB)',
            'Estimate Energy Value (THB)']
        const tableData = [];
        tableData.push(tableheader.join(","));
        for (const row of chart_plot.CSV_Data) {
            const rowData = [];
            if (row["date"] !== null) {
                if (row["date"] !== "-") {
                    if (row["date"] !== null) {
                        rowData.push(row["date"].replaceAll(",", ""))
                    } else { rowData.push('') }

                    if (row["solar"] !== null) {
                        rowData.push(row["solar"])
                    } else { rowData.push('') }

                    if (row["pr_ens"] !== null) {
                        rowData.push(row["pr_ens"])
                    } else { rowData.push('') }

                    if (row["orx_ens"] !== null) {
                        rowData.push(row["orx_ens"])
                    } else { rowData.push('') }

                    if (row["ens"] !== null) {
                        rowData.push(row["ens"])
                    } else { rowData.push('') }

                    if (row["co2"] !== null) {
                        rowData.push(row["co2"])
                    } else { rowData.push('') }

                    if (row["saving"] !== null) {
                        rowData.push(row["saving"])
                    } else { rowData.push('') }

                    if (row["value"] !== null) {
                        rowData.push(row["value"])
                    } else { rowData.push('') }

                    tableData.push(rowData.join(","));
                }
            }
        }

        let data = tableData.join("\n");
        const a = document.createElement("a");
        a.href = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
        var fnamey = 'Performance_' + chart_plot.FileName + '.csv'
        a.setAttribute("download", fnamey);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    function reset_chart() {
        setChart_plot({
            FileName: '',
            CSV_Data: [],
            XLabel: '',
            Sitename: '-',
            Energy: [],
            PR: [],
            PRG: [],
            ORx: [],
            ORG: [],
            ENS: [],
            Saving: [],
            Value: [],
            CO2: [],
            Approx: [],
            errorx: [],
            CODData: null,
            Chart1_Style: { unit: "kWh", digit: 3, type: "column", axis_y1: 'Solar Energy (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
            Chart2_Style: { unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
            Chart3_Style: { unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
            Chart4_Style: { unit: "kWh", digit: 3, type: "column", axis_y1: 'Energy not Supply (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
            Chart5_Style: { unit: "Ton", digit: 3, type: "column", axis_y1: 'CO2 Reduction (Ton)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
            Chart6_Style: { unit: "THB", digit: 3, type: "column", axis_y1: 'Saving (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
            Chart7_Style: { unit: "THB", digit: 3, type: "column", axis_y1: 'Energy Value (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
            summary: { Energy: 0, PRx: 0, ORx: 0, ENS: 0, Saving: 0, Value: 0, CO2: 0 },
            summary_unit: { Energy: "-", PRx: "-", ORx: "-", ENS: "-", Saving: "-", Value: "-", CO2: "-", },
            unit_rate: [],
            co2_factor: []
        })
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-table-search color-orange"></i> Performance</h4>
                                    <p className="mb-0">Query your energy production performance</p>
                                </div>
                                {
                                    !props.iscenter ?
                                        <div>
                                            {BackCenter()}
                                        </div>
                                        : null
                                }
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="d-flex gap-1 flex-wrap mb-4 print-disable">
                        {
                            props.iscenter ?
                                <div className="d-block">
                                    <label htmlFor="reportsite" className="form-label mb-0">Select Site</label>
                                    <select id="reportsite" name="reportsite" className="form-select font-sarabun" value={reportsite} onChange={(e) => {
                                        setReportsite(e.target.value)
                                    }} required>
                                        {
                                            props.permitdata !== null ?
                                                props.permitdata.sitescope_arr.map((data, index) => (
                                                    <option value={data.sitecode_txt} key={data.sitecode_txt}>{data.sitecode_txt} {data.sitename_th}</option>
                                                ))
                                                :
                                                null
                                        }
                                    </select>
                                </div>
                                : null
                        }
                        <div className="d-block" style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select Type</label>
                            <select id="reporttype" name="reporttype" className="form-select" value={reporttype} onChange={(e) => {
                                setReporttype(e.target.value)
                            }} required>
                                <option value="daily">Daily</option>
                                <option value="monthly">Monthly</option>
                                <option value="yearly">Yearly</option>
                                <option value="cod">From COD</option>
                            </select>
                        </div>
                        <div className={reporttype !== "cod" ? "d-block " : "d-none"} style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select {calendar_text}</label>
                            <Calendar
                                allowClear={false}
                                className={"form-control"}
                                onChange={onCalendaraChange}
                                picker={reporttype_picker}
                                style={{
                                    fontFamily: "poppins",
                                    fontSize: "0.75rem",
                                    Color: "black",
                                    lineHeight: "1.5",
                                    cursor: "pointer",
                                }}
                                value={reportdate_dt}
                                disabledDate={disabledCalendar}
                            />
                        </div>
                        <div className='d-flex'>
                            <div className="d-block align-self-end print-disable" style={{ paddingBottom: "3px" }}>
                                <button className="btn btn-info btn-sm me-5" onClick={() => { api_query() }}><i className="fas fa-search "></i> Query</button>
                            </div>
                            <div className="d-block align-self-end print-disable">
                                <div className="d-flex gap-1 mt-3 mt-lg-0" style={{ marginBottom: "3px" }}>
                                    <button className="btn btn-secondary btn-sm " onClick={() => { export_csv() }}><i className="fas fa-file-csv "></i> Export CSV</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 col-xxxl-6">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-3">
                                    <div className='d-flex  justify-content-between mb-2'>
                                        <div className='d-block'>
                                            <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Solar Energy</h5>
                                            <h6 className="card-title mb-0 font-sarabun">{chart_plot.Sitename}</h6>
                                        </div>
                                        <div className="performance-box">
                                            <div className="performance-value">
                                                <div className="performance-number">
                                                    {chart_plot.summary.Energy}
                                                </div>
                                                <div className="performance-unit">
                                                    {chart_plot.summary_unit.Energy}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CanvasJSReact_ChartPerformance
                                        xlabel={chart_plot.XLabel}
                                        plotdata={chart_plot.Energy}
                                        tooltip_onpeak={chart_plot.Energy_onpeak}
                                        tooltip_offpeak={chart_plot.Energy_offpeak}
                                        plotcolor="#2ECC71"
                                        plotname="Solar Energy"
                                        chart_style={chart_plot.Chart1_Style}
                                        cod={chart_plot.CODData}
                                        max={null}
                                        interval={null}
                                        holiday={chart_plot.holiday}
                                        prefix_tool={""}
                                    ></CanvasJSReact_ChartPerformance>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 col-xxxl-6">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-3">
                                    <div className='d-flex  justify-content-between mb-2'>
                                        <div className='d-block'>
                                            <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Performance Ratio</h5>
                                            <h6 className="card-title mb-0 font-sarabun">{chart_plot.Sitename}</h6>
                                        </div>
                                        <div className="performance-box">
                                            <div className="performance-value">
                                                <div className="performance-number">
                                                    {chart_plot.summary.PRx >= 100 ? "100" : chart_plot.summary.PRx}
                                                </div>
                                                <div className="performance-unit">
                                                    {chart_plot.summary_unit.PRx}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CanvasJSReact_ChartPerformance
                                        xlabel={chart_plot.XLabel}
                                        plotdata={chart_plot.PR}
                                        plotcolor="#3498DB"
                                        plotname="Performance Ratio"
                                        plotcolor2="#E94646"
                                        plotname2="PR Guarantee"
                                        plotdata2={chart_plot.PRG}
                                        chart_style={chart_plot.Chart2_Style}
                                        cod={chart_plot.CODData}
                                        max={120}
                                        interval={20}
                                        error={chart_plot.errorx}
                                        holiday={chart_plot.holiday}
                                    ></CanvasJSReact_ChartPerformance>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 col-xxxl-6">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-3">
                                    <div className='d-flex  justify-content-between mb-2'>
                                        <div className='d-block'>
                                            <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Operation Ratio</h5>
                                            <h6 className="card-title mb-0 font-sarabun">{chart_plot.Sitename}</h6>
                                        </div>
                                        <div className="performance-box">
                                            <div className="performance-value">
                                                <div className="performance-number">
                                                    {chart_plot.summary.ORx >= 100 ? "100" : chart_plot.summary.ORx}
                                                </div>
                                                <div className="performance-unit">
                                                    {chart_plot.summary_unit.ORx}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CanvasJSReact_ChartPerformance
                                        xlabel={chart_plot.XLabel}
                                        plotdata={chart_plot.ORx}
                                        plotcolor="#3498DB"
                                        plotname="Operation Ratio"
                                        plotcolor2="#E94646"
                                        plotname2="OR Guarantee"
                                        plotdata2={chart_plot.ORG}
                                        chart_style={chart_plot.Chart3_Style}
                                        cod={chart_plot.CODData}
                                        max={120}
                                        interval={20}
                                        error={chart_plot.errorx}
                                        holiday={chart_plot.holiday}
                                    ></CanvasJSReact_ChartPerformance>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 col-xxxl-6">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-3">
                                    <div className='d-flex  justify-content-between mb-2'>
                                        <div className='d-block'>
                                            <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Energy not Supply</h5>
                                            <h6 className="card-title mb-0 font-sarabun">{chart_plot.Sitename}</h6>
                                        </div>
                                        <div className="performance-box">
                                            <div className="performance-value">
                                                <div className="performance-number">
                                                    {chart_plot.summary.ENS}
                                                </div>
                                                <div className="performance-unit">
                                                    {chart_plot.summary_unit.ENS}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CanvasJSReact_ChartPerformance
                                        xlabel={chart_plot.XLabel}
                                        plotdata={chart_plot.ENS}
                                        plotcolor="#566573"
                                        plotname="Energy Not Supply"
                                        chart_style={chart_plot.Chart4_Style}
                                        cod={chart_plot.CODData}
                                        max={null}
                                        interval={null}
                                        error={chart_plot.errorx}
                                        holiday={chart_plot.holiday}
                                    ></CanvasJSReact_ChartPerformance>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 col-xxxl-6">
                            <div className="card card-common">
                                <div className="card-body pb-3">
                                    <div className='d-flex  justify-content-between mb-2'>
                                        <div className='d-block'>
                                            <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> CO<sub>2</sub> Reduction</h5>
                                            <h6 className="card-title mb-0 font-sarabun">{chart_plot.Sitename}</h6>
                                        </div>
                                        <div className="performance-box">
                                            <div className="performance-value">
                                                <div className="performance-number">
                                                    {chart_plot.summary.CO2}
                                                </div>
                                                <div className="performance-unit">
                                                    {chart_plot.summary_unit.CO2}CO<sub>2</sub>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CanvasJSReact_ChartPerformance
                                        xlabel={chart_plot.XLabel}
                                        plotdata={chart_plot.CO2}
                                        plotcolor="#8E44AD"
                                        plotname="CO2 Reduction"
                                        chart_style={chart_plot.Chart5_Style}
                                        cod={chart_plot.CODData}
                                        max={null}
                                        interval={null}
                                        co2factor={chart_plot.co2_factor}
                                        holiday={chart_plot.holiday}
                                    ></CanvasJSReact_ChartPerformance>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 col-xxxl-6">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-3">
                                    <div className='d-flex  justify-content-between mb-2'>
                                        <div className='d-block'>
                                            <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Estimate Saving</h5>
                                            <h6 className="card-title mb-0 font-sarabun">{chart_plot.Sitename}</h6>
                                        </div>
                                        <div className="performance-box">
                                            <div className="performance-value">
                                                <div className="performance-number">
                                                    {chart_plot.summary.Saving}
                                                </div>
                                                <div className="performance-unit">
                                                    {chart_plot.summary_unit.Saving}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CanvasJSReact_ChartPerformance
                                        xlabel={chart_plot.XLabel}
                                        plotdata={chart_plot.Saving}
                                        tooltip_onpeak={chart_plot.Saving_onpeak}
                                        tooltip_offpeak={chart_plot.Saving_offpeak}
                                        tooltip_usage={chart_plot.Saving_usage}
                                        tooltip_ft={chart_plot.Saving_ft}
                                        plotcolor="#F1C40F"
                                        plotname="Estimate Saving"
                                        chart_style={chart_plot.Chart6_Style}
                                        cod={chart_plot.CODData}
                                        max={null}
                                        interval={null}
                                        unitrate={chart_plot.unit_rate}
                                        unitrate_onpeak={chart_plot.unit_rate_onpeak}
                                        unitrate_offpeak={chart_plot.unit_rate_offpeak}
                                        ft_val={chart_plot.ft_val}
                                        holiday={chart_plot.holiday}
                                        prefix_tool={"Discount"}
                                    ></CanvasJSReact_ChartPerformance>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 col-xxxl-6">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-3">
                                    <div className='d-flex  justify-content-between mb-2'>
                                        <div className='d-block'>
                                            <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Estimate Energy Value</h5>
                                            <h6 className="card-title mb-0 font-sarabun">{chart_plot.Sitename}</h6>
                                        </div>
                                        <div className="performance-box">
                                            <div className="performance-value">
                                                <div className="performance-number">
                                                    {chart_plot.summary.Value}
                                                </div>
                                                <div className="performance-unit">
                                                    {chart_plot.summary_unit.Value}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CanvasJSReact_ChartPerformance
                                        xlabel={chart_plot.XLabel}
                                        plotdata={chart_plot.Value}
                                        tooltip_onpeak={chart_plot.Value_onpeak}
                                        tooltip_offpeak={chart_plot.Value_offpeak}
                                        tooltip_usage={chart_plot.Value_usage}
                                        tooltip_ft={chart_plot.Value_ft}
                                        plotcolor="#3498DB"
                                        plotname="Estimate Energy Value"
                                        chart_style={chart_plot.Chart7_Style}
                                        cod={chart_plot.CODData}
                                        max={null}
                                        interval={null}
                                        unitrate={chart_plot.unit_rate}
                                        unitrate_onpeak={chart_plot.unit_rate_onpeak}
                                        unitrate_offpeak={chart_plot.unit_rate_offpeak}
                                        ft_val={chart_plot.ft_val}
                                        holiday={chart_plot.holiday}
                                        prefix_tool={""}
                                    ></CanvasJSReact_ChartPerformance>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ScrollToTopButton />
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default MeasurementPerformance